import {
  Button as RACButton,
  ButtonProps as RACButtonProps,
} from "react-aria-components";
import { IconType } from "../../foundations/Icons/types";
import Icon from "../../foundations/Icons/Icon";
import { cn } from "../../cn";

export interface ButtonProps extends RACButtonProps {
  icon: IconType;
}

export default function ActionButton({
  icon,
  className,
  ...props
}: ButtonProps) {
  return (
    <RACButton
      {...props}
      className={cn(
        "w-20 h-12 flex items-center bg-grey-2 justify-center rounded-9",
        className,
      )}
    >
      <Icon icon={icon} className="bg-black size-6" size="sm" />
    </RACButton>
  );
}
